let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a6fZ3")).then(() => parcelRequire('iU0KE'));